export const MAIN_TITLE_SIZE = 22; // h1
export const SECTION_TITLE_SIZE = 18; // h2
export const CONTENT_TITLE_SIZE = 18; // h3
export const SUB_TITLE_SIZE = 16; // h4
